import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-8Q-logo_svg__svg5438",
  version: "1.1",
  viewBox: "0 0 96 87.9"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-8Q-logo_svg__st0{fill:none;stroke:#1d4a94;stroke-miterlimit:28.3;stroke-width:0}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      id: "svg-8Q-logo_svg__path4220",
      d: "M54.8 87.8c-22.7 0-41.2-18.5-41.2-41.2S32 5.4 54.8 5.4 96 23.9 96 46.6 77.5 87.8 54.8 87.8m0-78.4c-20.5 0-37.2 16.7-37.2 37.2s16.7 37.2 37.2 37.2S92 67.1 92 46.6 75.3 9.4 54.8 9.4",
      style: {"fill":"#1d4a94"}
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      id: "svg-8Q-logo_svg__path4224",
      d: "M54.8 87.8c-22.7 0-41.2-18.5-41.2-41.2S32 5.4 54.8 5.4 96 23.9 96 46.6 77.5 87.8 54.8 87.8Z",
      class: "svg-8Q-logo_svg__st0"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      id: "svg-8Q-logo_svg__path4228",
      d: "M54.8 9.4c-20.5 0-37.2 16.7-37.2 37.2s16.7 37.2 37.2 37.2S92 67.1 92 46.6 75.3 9.4 54.8 9.4Z",
      class: "svg-8Q-logo_svg__st0"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      id: "svg-8Q-logo_svg__path4232",
      d: "M0 52.4h80.7L36.6 0H17.1l20.4 48.8",
      style: {"fill":"#db1f26"}
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "8Q-logo"}) } }